import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Sub-aba "Categorías" da aba Artículos (Operar Cliente / Área do Contador).
 *
 * Wrapper fino que reusa o componente COMPLETO de gestão de categorias
 * (`app-grupo`) em modo EMBUTIDO, sob o contexto do cliente (X-Empresa-Contexto).
 * Assim o contador consulta, ADICIONA e EDITA as categorias do cliente com o
 * mesmo formulário da tela principal. Excluir fica de fora (backend só libera
 * GET/POST/PUT de /grupo sob contexto).
 *
 * O componente pesado resolve a empresa (e carrega a lista) no ngOnInit, então é
 * RE-MONTADO ao abrir a aba e ao trocar de cliente — mesmo padrão do operar-itens.
 */
@Component({
  selector: 'app-operar-categorias',
  templateUrl: './operar-categorias.component.html',
})
export class OperarCategoriasComponent implements OnChanges {
  /** Id da empresa do cliente — muda quando o contador troca de cliente. */
  @Input() clienteEmpresaId?: number | null;

  /** Indica se a sub-aba está ativa; monta o componente pesado quando abre. */
  @Input() ativo = false;

  /** Controla a existência do componente pesado (montagem sob demanda + re-mount). */
  montado = false;

  ngOnChanges(changes: SimpleChanges): void {
    const abriuAgora =
      !!changes['ativo'] && this.ativo && changes['ativo'].previousValue !== true;
    const trocouCliente =
      !!changes['clienteEmpresaId'] && !changes['clienteEmpresaId'].firstChange;

    if (changes['ativo'] && !this.ativo) {
      this.montado = false;
      return;
    }

    if (abriuAgora || (trocouCliente && this.ativo)) {
      if (this.montado) {
        this.montado = false;
        Promise.resolve().then(() => {
          this.montado = true;
        });
      } else {
        this.montado = true;
      }
    }
  }
}
